module.exports = __webpack_public_path__ + "img/logout.fac65b8d.svg";